import { Inject, Injectable } from '@angular/core';
import {
  API_ENDPOINTS,
  ApiEndpoints,
  ApiResponse,
  LocationTierKey,
  MeterQuery,
  ModuleType,
} from '@contracts';
import { ApiCilent } from '@core';
import { Observable } from 'rxjs';
import { SENSOR_TYPE, UpdateNewMeter } from '../interface/meter';

@Injectable({
  providedIn: 'root',
})
export class MeterService {
  constructor(
    private readonly apiClient: ApiCilent,
    @Inject(API_ENDPOINTS) private readonly endpoints: ApiEndpoints,
  ) {}

  getLovLocation(query: any): Observable<ApiResponse<string[]>> {
    return this.apiClient.get({
      path: 'locations',
      version:'v2',
      query,
    });
  }

  getMeters(query: MeterQuery): Observable<ApiResponse<any>> {
    const endpoint = this.endpoints.meter.list;

    return this.apiClient.get({
      domain: endpoint.domain,
      version: endpoint.version,
      path: endpoint.path,
      query,
    });
  }

  createMeter(payload: any): Observable<any> {
    const endpoint = this.endpoints.meter.create;

    return this.apiClient.post({
      domain: endpoint.domain,
      version: endpoint.version,
      // path: '',
      path: endpoint.path,
      body: payload,
    });
  }

  updateMeter(payload: UpdateNewMeter): Observable<any> {
    const endpoint = this.endpoints.meter.update;

    return this.apiClient.put({
      domain: endpoint.domain,
      version: endpoint.version,
      path: endpoint.path,
      body: payload,
    });
  }

  deleteMeter(payload: any): Observable<any> {
    const endpoint = this.endpoints.meter.delete;

    return this.apiClient.delete({
      domain: endpoint.domain,
      version: endpoint.version,
      path: endpoint.path,
      body: payload,
    });
  }

  meterTestSync(payload: any): Observable<any> {
    const endpoint = this.endpoints.meter.testSync;

    return this.apiClient.post({
      domain: endpoint.domain,
      version: endpoint.version,
      path: endpoint.path,
      body: payload,
    });
  }

  getBrand(type: string): Observable<any> {
    const endpoint = this.endpoints.meter.brands;

    return this.apiClient.get({
      domain: endpoint.domain,
      version: endpoint.version,
      path: endpoint.path,
      query: { type },
    });
  }

  getPanels(type: string): Observable<any> {
    const endpoint = this.endpoints.meter.panels;

    return this.apiClient.get({
      domain: endpoint.domain,
      version: endpoint.version,
      path: endpoint.path,
      query: { type },
    });
  }

  getLoops(type: string): Observable<any> {
    const endpoint = this.endpoints.meter.loops;

    return this.apiClient.get({
      domain: endpoint.domain,
      version: endpoint.version,
      path: endpoint.path,
      query: { type },
    });
  }

  getTags(type: string): Observable<any> {
    const endpoint = this.endpoints.meter.tags;

    return this.apiClient.get({
      domain: endpoint.domain,
      version: endpoint.version,
      path: endpoint.path,
      query: { type },
    });
  }

  getTenants(type: string): Observable<any> {
    const endpoint = this.endpoints.meter.tenants;

    return this.apiClient.get({
      domain: endpoint.domain,
      version: endpoint.version,
      path: endpoint.path,
      query: { type },
    });
  }

  getLocations(type: string, key?: LocationTierKey): Observable<any> {
    const endpoint = this.endpoints.meter.locations;

    return this.apiClient.get({
      domain: endpoint.domain,
      version: endpoint.version,
      path: endpoint.path,
      query: { type, key },
    });
  }

  getPublicUnit(): Observable<any> {
    const endpoint = this.endpoints.meter.publicUnits;

    return this.apiClient.get({
      domain: endpoint.domain,
      version: endpoint.version,
      path: endpoint.path,
    });
  }

  getGroups(): Observable<any> {
    const endpoint = this.endpoints.meter.groups;

    return this.apiClient.get({
      domain: endpoint.domain,
      version: endpoint.version,
      path: endpoint.path,
    });
  }
}
